import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { KeyCode } from '../../../../wui-core/src';
import { polyfill } from 'react-lifecycles-compat';
import moment from 'moment';
import { formatDate } from '../util';
var cachedSelectionStart;
var cachedSelectionEnd;
var dateInputInstance;

var DateInput = /*#__PURE__*/function (_React$Component) {
  _inherits(DateInput, _React$Component);

  var _super = _createSuper(DateInput);

  function DateInput(props) {
    var _this;

    _classCallCheck(this, DateInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      _this.setState({
        str: ''
      });

      _this.props.onClear(null);
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event) {
      var str = event.target.value;
      var _this$props = _this.props,
          disabledDate = _this$props.disabledDate,
          format = _this$props.format,
          onChange = _this$props.onChange,
          selectedValue = _this$props.selectedValue,
          validatorFunc = _this$props.validatorFunc; // 没有内容，合法并直接退出

      if (!str) {
        onChange(null);

        _this.setState({
          // invalid: false,
          str: str
        });

        return;
      } // 不合法直接退出


      var parsed = moment(str, format, true);

      if (!parsed.isValid()) {
        _this.setState({
          // invalid: true,
          str: str
        });

        return;
      }

      if (!_this.props.validatorFunc(str)) {
        _this.setState({
          str: str
        });

        return;
      }

      ;

      var value = _this.props.value.clone();

      value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

      if (!value || disabledDate && disabledDate(value)) {
        _this.setState({
          // invalid: true,
          str: str
        });

        return;
      } // 如果上次值不合法，此次值合法，把此次值更新到datepicker的value中


      if (parsed.isValid && parsed.isValid() && !value.isValid()) {
        _this.setState({
          str: str
        }, function () {
          return _this.props.onChange(parsed);
        });
      }

      if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
        _this.setState({
          // invalid: false,
          str: str
        });

        if (value.isValid && !value.isValid()) {
          // value不合法，把此次的新输入的合法值传到onChange中
          onChange(parsed);
        } else {
          onChange(value);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      _this.setState({
        hasFocus: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      var str = e.target.value;
      var _this$props2 = _this.props,
          disabledDate = _this$props2.disabledDate,
          format = _this$props2.format,
          onChange = _this$props2.onChange,
          selectedValue = _this$props2.selectedValue; // 没有内容，合法并直接退出

      if (!str) {
        _this.setState({
          invalid: false
        });

        return;
      } // 不合法直接退出


      var parsed = moment(str, format, true);

      if (parsed.isValid && !parsed.isValid()) {
        _this.setState({
          invalid: true
        });

        return;
      }

      if (!_this.props.validatorFunc(str)) {
        _this.setState({
          invalid: true
        });

        return;
      }

      ;

      var value = _this.props.value.clone();

      value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

      if (!value || disabledDate && disabledDate(value)) {
        _this.setState({
          invalid: true
        });

        return;
      }

      if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
        _this.setState({
          invalid: false
        });
      }

      _this.setState(function (prevState, prevProps) {
        return {
          hasFocus: false,
          str: formatDate(prevProps.value, prevProps.format)
        };
      });

      _this.props.onBlur && _this.props.onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$props3 = _this.props,
          onSelect = _this$props3.onSelect,
          value = _this$props3.value,
          onKeyDown = _this$props3.onKeyDown,
          format = _this$props3.format,
          isRange = _this$props3.isRange,
          validatorFunc = _this$props3.validatorFunc,
          disabledDate = _this$props3.disabledDate;
      var str = e.target.value;
      var parsed = moment(str, format, true);

      if (e.keyCode === KeyCode.ENTER) {
        if (parsed.isValid && parsed.isValid() && onSelect) {
          isRange ? onSelect(parsed.clone()) : onSelect(value.clone()); //FIX https://github.com/iuap-design/tinper-bee/issues/183
        } // 没有内容，回填默认值，并关闭面板


        if (!str) {
          _this.setState({
            invalid: false
          });

          onSelect && onSelect(moment());
          return;
        } // 有内容，判断是否合法


        if (parsed.isValid && !parsed.isValid()) {
          _this.setState({
            invalid: true
          });
        }

        if (!validatorFunc(str)) {
          _this.setState({
            invalid: true
          });
        }

        value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

        if (!value || disabledDate && disabledDate(value)) {
          _this.setState({
            invalid: true
          });
        }
      } // if (e.keyCode === KeyCode.ENTER && onSelect) {
      //   onSelect(value.clone());
      // }


      onKeyDown && onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "getRootDOMNode", function () {
      return ReactDOM.findDOMNode(_assertThisInitialized(_this));
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      if (dateInputInstance) {
        dateInputInstance.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveDateInput", function (dateInput) {
      dateInputInstance = dateInput;
    });

    var _selectedValue = props.selectedValue;
    _this.state = {
      str: formatDate(_selectedValue, _this.props.format),
      invalid: false,
      hasFocus: false
    };
    return _this;
  }

  _createClass(DateInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (dateInputInstance && this.state.hasFocus && !this.state.invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
        dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var _this$state = this.state,
          invalid = _this$state.invalid,
          str = _this$state.str;
      var locale = props.locale,
          prefixCls = props.prefixCls,
          placeholder = props.placeholder,
          clearIcon = props.clearIcon,
          renderError = props.renderError,
          inputTabIndex = props.inputTabIndex,
          inputReadOnly = props.inputReadOnly;
      var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-input-wrap")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-date-input-wrap")
      }, /*#__PURE__*/React.createElement("input", {
        ref: this.saveDateInput,
        className: "".concat(prefixCls, "-input ").concat(invalidClass),
        value: str ? str : formatDate(props.selectedValue, props.format),
        disabled: props.disabled,
        placeholder: placeholder,
        onChange: this.onInputChange,
        onKeyDown: this.onKeyDown,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        readOnly: inputReadOnly,
        tabIndex: inputTabIndex
      }), invalid && renderError ? renderError() : ''), props.showClear ? /*#__PURE__*/React.createElement("a", {
        role: "button",
        title: locale.clear,
        onClick: this.onClear
      }, clearIcon || /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-clear-btn uf uf-close-c")
      })) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var newState = {};

      if (dateInputInstance) {
        cachedSelectionStart = dateInputInstance.selectionStart;
        cachedSelectionEnd = dateInputInstance.selectionEnd;
      } // when popup show, click body will call this, bug!


      var selectedValue = nextProps.selectedValue;

      if (!state.hasFocus) {
        newState = {
          str: formatDate(selectedValue, nextProps.format),
          invalid: false
        };
      }

      return newState;
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      return dateInputInstance;
    }
  }]);

  return DateInput;
}(React.Component);

_defineProperty(DateInput, "propTypes", {
  prefixCls: PropTypes.string,
  timePicker: PropTypes.object,
  value: PropTypes.object,
  disabledTime: PropTypes.any,
  format: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  locale: PropTypes.object,
  disabledDate: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func,
  //selectedValue: PropTypes.object,
  selectedValue: PropTypes.any,
  clearIcon: PropTypes.node
});

polyfill(DateInput);
export default DateInput;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/date/DateInput.js